module.exports = __webpack_public_path__ + "static/media/portada.32c02067.jpg";